import axiosClient from "api/axios_client.js";

const apiModuleMaster = {
  getAllModuleMaster: (payload) => axiosClient.post(`user-role-module/module-master/get-all`, payload),
  getAllModules: () => axiosClient.get(`user-role-module/module-master/get-all`),
  getById: (id) => axiosClient.get(`user-role-module/module-master/get-by-id/${id}`),
  create: (payload) => axiosClient.post(`user-role-module/module-master/create`, payload),
  update: (id, payload) => axiosClient.put(`user-role-module/module-master/update/${id}`, payload),
  toggleStatus: (id) => axiosClient.put(`user-role-module/module-master/toggle-status/${id}`),
  delete: (ids) => axiosClient.delete(`user-role-module/module-master/delete`, { data: { ids } }), 
};

export default apiModuleMaster;
